import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'RELEASE_NOTES';

export const showReleaseNotesDialog = createAction(
  rootUiActions.createDialog.toString(),
  () => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    allowNesting: true,
  }),
);
